import React, { useState, useEffect, useRef } from "react";
import axios from "../../utils/axiosConfig";
import { BASE_URL } from "../../utils/config";
import "../Facilities/Facility.css";

const API_URL = "/api/facility";
const IMAGE_URL = `${BASE_URL}/uploads/facility/`;

const Facility = () => {

const [facilities, setFacilities] = useState([]);
const [selectedIndex, setSelectedIndex] = useState(null);
const [lightboxOpen, setLightboxOpen] = useState(false);

const modalRef = useRef(null);
const trackRef = useRef(null);

/* ================= LOAD DATA FROM DATABASE ================= */

const loadFacilities = async () => {
try {

  const response = await axios.get(API_URL);
  setFacilities(response.data);

} catch (error) {

  console.error("Error loading facilities:", error);
}
};

useEffect(() => {
loadFacilities();
}, []);

/* ================= MODAL ================= */
const openModal = (index) => {
setSelectedIndex(index);
};

const closeModal = () => {
setSelectedIndex(null);
};

const handleOverlayClick = (e) => {
if (modalRef.current && !modalRef.current.contains(e.target)) {

  closeModal();
}
};

/* ================= LIGHTBOX ================= */
const openLightbox = () => {
setLightboxOpen(true);
};

const closeLightbox = () => {
setLightboxOpen(false);
};

/* ================= KEYBOARD SUPPORT ================= */
useEffect(() => {
const handleKey = (e) => {
  if (e.key === "Escape") {

    if (lightboxOpen) {
      closeLightbox();
    } else {
      closeModal();
    }
  }

  if (selectedIndex !== null && !lightboxOpen) {
    if (e.key === "ArrowRight") {

      setSelectedIndex(prev =>
        prev === facilities.length - 1 ? 0 : prev + 1
      );
    }

    if (e.key === "ArrowLeft") {
      setSelectedIndex(prev =>
        prev === 0 ? facilities.length - 1 : prev - 1
      );
    }
  }
};

window.addEventListener("keydown", handleKey);

return () => window.removeEventListener("keydown", handleKey);
}, [selectedIndex, lightboxOpen, facilities]);

/* ================= THUMBNAIL SCROLL ================= */
const scrollLeft = () => {
if (trackRef.current) {
  trackRef.current.scrollBy({ left: -200, behavior: "smooth" });
}
};

const scrollRight = () => {
if (trackRef.current) {
  trackRef.current.scrollBy({ left: 200, behavior: "smooth" });
}
};

return (
<section className="facility-section">
  <div className="facility-container">
    <h2 className="facility-title">ACADEMIC FACILITIES</h2>
    <p className="facility-subtitle">
    The School follows workshop method of instruction & students are
        encouraged to learn by doing practically. The School has highly
        qualified and competent staff. All the teaching staff is trained and
        well versed in their subjects.
    </p>

    {/* ================= FACILITY GRID ================= */}
    <div className="facility-grid">
      {facilities.map((item, index) => (

        <div
          key={item.id}
          className="facility-card"
          onClick={() => openModal(index)}
        >
          <div className="facility-image-box">
            <img
              src={IMAGE_URL + item.image}
              alt={item.title}
            />
          </div>

          <div className="facility-card-body">
            <h4>{item.title}</h4>
            <p>{item.description}</p>
          </div>
        </div>
      ))}
    </div>

    {/* ================= MODAL ================= */}
    {selectedIndex !== null && facilities.length > 0 && (

      <div
        className="facility-modal-overlay"
        onClick={handleOverlayClick}
      >
        <div
          className="facility-modal"
          ref={modalRef}
        >

          {/* HEADER */}
          <div className="facility-modal-header">
            <h3 className="facility-modal-title">
              {facilities[selectedIndex].title}
            </h3>

            <button
              className="facility-close-btn"
              onClick={closeModal}
            >
              ×
            </button>
          </div>

          {/* BODY */}
          <div className="facility-modal-body">
            <div className="facility-description">
              {facilities[selectedIndex].description}
            </div>

            <div className="facility-main-image">
              <img
                src={IMAGE_URL + facilities[selectedIndex].image}
                alt=""
                onClick={openLightbox}
                style={{ cursor: "zoom-in" }}
              />
            </div>
          </div>

          {/* THUMBNAILS */}
          <div className="facility-thumbnails">

            <button
              className="thumb-arrow"
              onClick={scrollLeft}
            >
              ‹
            </button>

            <div
              className="thumb-track"
              ref={trackRef}
            >
            {facilities.map((item, idx) => (
                <div
                  key={item.id}
                  className="thumb-item"
                >
                  <img
                    src={IMAGE_URL + item.image}
                    alt=""
                    className={
                      idx === selectedIndex
                        ? "thumb-active"
                        : ""
                    }
                    onClick={() => setSelectedIndex(idx)}
                  />
                  <span>{item.title}</span>
                </div>
              ))}
            </div>
            <button
              className="thumb-arrow"
              onClick={scrollRight}
            >
              ›
            </button>

          </div>
        </div>
      </div>
    )}

    {/* ================= LIGHTBOX ================= */}
    {lightboxOpen && selectedIndex !== null && (

      <div
        className="facility-lightbox"
        onClick={closeLightbox}
      >

        <img
          src={IMAGE_URL + facilities[selectedIndex].image}
          alt=""
        />
      </div>
    )}
  </div>
</section>
);
};

export default Facility;
